angular.module('dnecom')
    .directive('validationSlug', ["$q", "$parse", "$http", function ($q, $parse, $http) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                var data = $parse(attrs.validationSlug)(scope);

                ngModelController.$asyncValidators.validationSlug = function (modelValue, viewValue) {
                    // don't validate slug on page startup
                    if (!element.data('initialized')) {
                        element.data('initialized', '1');
                        return $q.when(true);
                    }

                    if (ngModelController.$isEmpty(modelValue)) {
                        return $q.when(true);
                    }

                    var slug = viewValue.replace(/ +/g, '-').replace(/[^a-zA-Z0-9_\-]+/g, '').toLowerCase();

                    ngModelController.$setViewValue(slug);
                    ngModelController.$render();
                    scope.$apply();

                    var deffered = $q.defer();

                    $http.post(Routing.generate('products_validate_slug', {
                            id: data.storeId,
                            productId: data.id || 0
                        }), { slug: slug })
                        .then(function (response) {
                            if (!response.data.success) {
                                deffered.reject();
                            } else {
                                deffered.resolve();
                            }
                        }, function () {
                            deffered.reject();
                        });

                    return deffered.promise;
                }
            }
        }
    }]);

